/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  BookingSummaryApiResource,
  GetApiBookingExportParams,
  GetApiBookingList200,
  GetApiBookingListParams,
  NotFoundErrorResponse,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

/**
 * Mark booking as checked in. Sets postCheckinAt field to current time and changes property cleanStatus to Dirty.
 */
export type postApiBookingCheckinResponse200 = {
  data: BookingSummaryApiResource
  status: 200
}

export type postApiBookingCheckinResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiBookingCheckinResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiBookingCheckinResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiBookingCheckinResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type postApiBookingCheckinResponseSuccess = (postApiBookingCheckinResponse200) & {
  headers: Headers;
};
export type postApiBookingCheckinResponseError = (postApiBookingCheckinResponse400 | postApiBookingCheckinResponse401 | postApiBookingCheckinResponse403 | postApiBookingCheckinResponse404) & {
  headers: Headers;
};

export type postApiBookingCheckinResponse = (postApiBookingCheckinResponseSuccess | postApiBookingCheckinResponseError)

export const getPostApiBookingCheckinUrl = (id: number,) => {


  

  return `/api/bookings/${id}/check-in`
}

export const postApiBookingCheckin = async (id: number, options?: RequestInit): Promise<postApiBookingCheckinResponse> => {
  
  return customFetch<postApiBookingCheckinResponse>(getPostApiBookingCheckinUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}


/**
 * Mark booking as checked out. Sets checkedOutAt field to current time.
 */
export type postApiBookingCheckoutResponse200 = {
  data: BookingSummaryApiResource
  status: 200
}

export type postApiBookingCheckoutResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiBookingCheckoutResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiBookingCheckoutResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiBookingCheckoutResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type postApiBookingCheckoutResponseSuccess = (postApiBookingCheckoutResponse200) & {
  headers: Headers;
};
export type postApiBookingCheckoutResponseError = (postApiBookingCheckoutResponse400 | postApiBookingCheckoutResponse401 | postApiBookingCheckoutResponse403 | postApiBookingCheckoutResponse404) & {
  headers: Headers;
};

export type postApiBookingCheckoutResponse = (postApiBookingCheckoutResponseSuccess | postApiBookingCheckoutResponseError)

export const getPostApiBookingCheckoutUrl = (id: number,) => {


  

  return `/api/bookings/${id}/check-out`
}

export const postApiBookingCheckout = async (id: number, options?: RequestInit): Promise<postApiBookingCheckoutResponse> => {
  
  return customFetch<postApiBookingCheckoutResponse>(getPostApiBookingCheckoutUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}


export type getApiBookingListResponse200 = {
  data: GetApiBookingList200
  status: 200
}

export type getApiBookingListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiBookingListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiBookingListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiBookingListResponseSuccess = (getApiBookingListResponse200) & {
  headers: Headers;
};
export type getApiBookingListResponseError = (getApiBookingListResponse400 | getApiBookingListResponse401 | getApiBookingListResponse403) & {
  headers: Headers;
};

export type getApiBookingListResponse = (getApiBookingListResponseSuccess | getApiBookingListResponseError)

export const getGetApiBookingListUrl = (params: GetApiBookingListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/bookings?${stringifiedParams}` : `/api/bookings`
}

export const getApiBookingList = async (params: GetApiBookingListParams, options?: RequestInit): Promise<getApiBookingListResponse> => {
  
  return customFetch<getApiBookingListResponse>(getGetApiBookingListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiBookingExportResponse200 = {
  data: Blob
  status: 200
}

export type getApiBookingExportResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiBookingExportResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiBookingExportResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiBookingExportResponseSuccess = (getApiBookingExportResponse200) & {
  headers: Headers;
};
export type getApiBookingExportResponseError = (getApiBookingExportResponse400 | getApiBookingExportResponse401 | getApiBookingExportResponse403) & {
  headers: Headers;
};

export type getApiBookingExportResponse = (getApiBookingExportResponseSuccess | getApiBookingExportResponseError)

export const getGetApiBookingExportUrl = (params: GetApiBookingExportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/bookings/export?${stringifiedParams}` : `/api/bookings/export`
}

export const getApiBookingExport = async (params: GetApiBookingExportParams, options?: RequestInit): Promise<getApiBookingExportResponse> => {
  
  return customFetch<getApiBookingExportResponse>(getGetApiBookingExportUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiBookingGetSummaryResponse200 = {
  data: BookingSummaryApiResource
  status: 200
}

export type getApiBookingGetSummaryResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiBookingGetSummaryResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiBookingGetSummaryResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiBookingGetSummaryResponseSuccess = (getApiBookingGetSummaryResponse200) & {
  headers: Headers;
};
export type getApiBookingGetSummaryResponseError = (getApiBookingGetSummaryResponse401 | getApiBookingGetSummaryResponse403 | getApiBookingGetSummaryResponse404) & {
  headers: Headers;
};

export type getApiBookingGetSummaryResponse = (getApiBookingGetSummaryResponseSuccess | getApiBookingGetSummaryResponseError)

export const getGetApiBookingGetSummaryUrl = (id: number,) => {


  

  return `/api/bookings/${id}/summary`
}

export const getApiBookingGetSummary = async (id: number, options?: RequestInit): Promise<getApiBookingGetSummaryResponse> => {
  
  return customFetch<getApiBookingGetSummaryResponse>(getGetApiBookingGetSummaryUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


